import StudentVideoStatEdit from './StudentVideoStatEdit';
import {Image} from "@mui/icons-material";
export default {
    edit: StudentVideoStatEdit,
    icon: Image,
};
